import script from "./BaseJournalPopup.vue?vue&type=script&setup=true&lang=ts"
export * from "./BaseJournalPopup.vue?vue&type=script&setup=true&lang=ts"

import "./BaseJournalPopup.vue?vue&type=style&index=0&id=190da599&lang=sass&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-190da599"]])

export default __exports__
import QTr from 'quasar/src/components/table/QTr.js';
import QTd from 'quasar/src/components/table/QTd.js';
import QSpinner from 'quasar/src/components/spinner/QSpinner.js';
import qInstall from "../../../node_modules/@quasar/app-webpack/lib/webpack/runtime.auto-import.js";
qInstall(script, 'components', {QTr,QTd,QSpinner});
